import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';

const ContinueButton = (props) => {
  const {className, onContinue} = props;

  return (
    <Button className={className} onClick={onContinue}>
      <FormattedMessage id="MapboxTooltipContinue.ContinueText" defaultMessage="Continue" />
    </Button>
  );
};

ContinueButton.propTypes = {
  /** The class name of the button. */
  className: PropTypes.string.isRequired,

  /** The function to be called when the button is clicked. */
  onContinue: PropTypes.func.isRequired,
};

export default ContinueButton;
